<!-- <div class="filter-section titles">

    <button class="btn-bg-color" mat-raised-button mat-flat-button (click)="gotoItems()">
        <mat-icon  matTooltip="Back to test items" matTooltipPosition="above">arrow_back</mat-icon>
      </button>
</div>



<div class="item-bank-list-container">
    <div class="">
        <div class="filter-section">
            <div class="">
                <div class="row">
                    <div class="col-md-9">
                        <div class="input-fields-wrapper">
                            <div class="input-wrapper">
                                <input type="text" class="form-control" [(ngModel)]='itemName' placeholder="Find by Item name">

                                <input type="text" class="form-control" [(ngModel)]='itemDescription'
                                    placeholder="Find by Description">

                                <input type="text" class="form-control" [(ngModel)]='tagDescription'
                                    placeholder="Find by Tag">
                            </div>
                            <div class="btn-wrapper">
                                <button (click)='itemFilter()' mat-flat-button mat-raised-button class="btn-bg-color">
                                    <span>Search</span>
                                </button>

                                <button class="btn-green-text" (click)='resetFilter()' mat-flat-button
                                    mat-raised-button>
                                    <span>Reset</span>
                            </button>

                            </div>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="btn-wrapper">
                            <button class="btn-bg-color" (click)="saveItemsToTest()" mat-raised-button mat-flat-button>
                                <span> + Add Items</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="container-fluid">
            <div *ngIf="isNoItems" class="data-not-found-container">
                <span>No Items in this Test</span>
            </div>
            <div *ngIf="!isNoItems" class="row">
            <div class="row">
                <div class="col-md-12">
                    <div class="table-container">
                            <table mat-table [dataSource]="items" matSort class="mat-elevation-z8">
                                <ng-container matColumnDef="itemBankName">
                                    <th mat-header-cell *matHeaderCellDef>Items </th>
                                    <td mat-cell *matCellDef="let row">

                                        <div class="item-box">
                                            <div>
                                                <mat-checkbox (change)="toggleCheckbox($event)" id="{{row.itemuuid}}">
                                                </mat-checkbox>
                                            </div>
                                            <div class="item-desc">
                                                <ng-container
                                                    *ngIf="row?.itemBankName?.length > 40 then sliceTitle else noSliceTitle">
                                                </ng-container>
                                                <ng-template  #sliceTitle>
                                                    <span class="text-bold" (click)='navigateToItemDetails(row.itemBankId)'
                                                        matTooltip="{{row?.itemBankName}}" matTooltipPosition="above">
                                                        {{row?.itemBankName | slice: 0:50}}...</span>
                                                </ng-template>
                                                <ng-template #noSliceTitle>
                                                    <span class="text-bold" (click)='navigateToItemDetails(row.itemBankId)'>{{row?.itemBankName
                                                        }}</span>
                                                </ng-template>



                                                <div class="test-desc">
                                                    <ng-container
                                                        *ngIf="row?.itemDescription?.length > 30 then sliceDescription else noSliceDescription">
                                                    </ng-container>
                                                    <ng-template #sliceDescription>
                                                        <span class="text-bold" (click)='navigateToItemDetails(row.itemBankId)'
                                                            matTooltipPosition="above"
                                                            matTooltip="{{row?.itemDescription}}">
                                                            {{row?.itemDescription | slice: 0:30}}...
                                                        </span>
                                                    </ng-template>
                                                    <ng-template #noSliceDescription>
                                                        <span class="text-bold" (click)='navigateToItemDetails(row.itemBankId)'>
                                                            {{row?.itemDescription }}
                                                        </span>
                                                    </ng-template>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="questiontype">
                                    <th mat-header-cell *matHeaderCellDef>Question types</th>
                                    <td mat-cell *matCellDef="let row" >
                                        {{row.questionTypes}}</td>
                                </ng-container>

                                <ng-container matColumnDef="itemStatus">
                                    <th mat-header-cell *matHeaderCellDef>Status</th>
                                    <td mat-cell *matCellDef="let row" >
                                        <i *ngIf="row?.statusName === 'Published'" class="fa fas fa-circle publish"
                                            matTooltip="Published"></i>
                                        <span *ngIf="row?.statusName === 'Unpublished'"
                                            class="glyphicon glyphicon-adjust unpublish"
                                            matTooltip="Unpublished"></span>
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="updated" >
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated</th>
                                    <td mat-cell *matCellDef="let row">
                                        <span class="text-bold"> {{row.modifiedUserName}} </span> <br> {{row.updated | dateAgo}}</td>
                                </ng-container>
                                <ng-container matColumnDef="tags">
                                    <th mat-header-cell *matHeaderCellDef>Tags</th>
                                    <td mat-cell *matCellDef="let row">
                                        <ng-container *ngIf="row?.tagdescription.length > 2; then Slicetag; else noSlicetag" ></ng-container>
                                        <ng-template #Slicetag>
                                           <div class="tag-data">
                                                <table>
                                                    <tr *ngFor="let ele of row.tagdescription">
                                                        <td [innerHtml]="ele | boldTag" matTooltip="{{row.tagdescription}}"></td>
                                                    </tr>
                                                </table>
                                           </div>
                                        </ng-template>
                                        <ng-template #noSlicetag>
                                            <table>
                                                <tr *ngFor="let ele of row.tagdescription">
                                                    <td [innerHtml]="ele | boldTag"></td>
                                                </tr>
                                            </table>
                                        </ng-template>
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" ></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            </table>
                            <div class="data-not-found-container" *ngIf="noDataFound">
                                <p>Data not found</p>
                              </div>

                    </div>
                    <div class="item-paginator">
                        <mat-paginator #paginator [pageSizeOptions]="[10, 50, 100]"></mat-paginator>

                    </div>
                </div>
            </div>
    </div>
</div> -->

<div class="module-wrapper content-wrapper">
  <div class="head-container">
    <!-- <button class="btn-bg-color" mat-raised-button mat-flat-button (click)="gotoItems()">
                <mat-icon  matTooltip="Back to test items" matTooltipPosition="above">arrow_back</mat-icon>
            </button> -->
    <!--  <button mat-flat-button color="" (click)="gotoItems()" class="btn-primary" aria-label="Back">
            <mat-icon  matTooltip="Back to test items" matTooltipPosition="above">arrow_back</mat-icon>
          </button>
          <h3>Existing Items</h3>-->
    <div class="btn-wrapper">
      <button mat-flat-button color="" class="btn-warn" (click)="gotoItems()" aria-label="Back">
        {{'testId.TabItems.existingItem.btnBack' | translate}}</button>
    </div>
    <span class="spacer"></span>
    <div>
      <div class="btn-wrapper">
        <button mat-flat-button color="" class="btn-warn" (click)="saveItemsToTest()" aria-label="Add New Item" [disabled]="isNoItems">
          + {{'testId.TabItems.existingItem.btnNew' | translate}}</button>
      </div>
    </div>
  </div>
  <div class="item-group" *ngIf="selectedGroupName != undefined">
    <div><strong>{{'testId.TabItems.existingItem.label' | translate}}: {{selectedGroupName?.itemCategoryName}}
    </strong></div>
  </div>
  <div class="input-container">
    <div class="input-fields-wrapper">
      <div class="input-wrapper">
        <input type="text" placeholder="{{'testId.TabItems.existingItem.inputName' | translate}}" [(ngModel)]="itemName" class="form-control ng-untouched ng-pristine ng-valid"
          ng-reflect-model="">
        <input type="text" placeholder="{{'testId.TabItems.existingItem.inputDesc' | translate}}" [(ngModel)]="itemDescription" class="form-control ng-untouched ng-pristine ng-valid"
          ng-reflect-model="">
        <input type="text" placeholder="{{'testId.TabItems.existingItem.inputTag' | translate}}" [(ngModel)]="tagDescription" class="form-control ng-untouched ng-pristine ng-valid"
          ng-reflect-model="">
      </div>
      <div class="btn-wrapper">
        <button mat-flat-button color="" (click)="itemFilter()" class="btn-primary" aria-label="Search">
          {{'testId.TabItems.existingItem.btnSearch' | translate}}
        </button>
        <button mat-flat-button color="" (click)="resetFilter()" class="btn-flat" aria-label="Reset">
          {{'testId.TabItems.existingItem.btnReset' | translate}}
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="isNoItems" class="data-not-found-container table-container">
    <span>{{'testId.TabItems.existingItem.noItemMsg' | translate}}</span>
  </div>
  <div *ngIf="!isNoItems">
    <div class="table-container">
      <table mat-table [dataSource]="items" matSort class="mat-elevation-z8">
        <!-- <ng-container matColumnDef="itemRenderOrder">
          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">Order</th>
          <td mat-cell *matCellDef="let row">
            <input type="text" [(ngModel)]="row.itemRenderOrder" class="mat-input" />
          </td>
        </ng-container> -->
        <ng-container matColumnDef="itemBankName">
          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">
            {{'testId.TabItems.existingItem.column1' | translate}}
          </th>
          <td mat-cell *matCellDef="let row; let i = index">
            <div class="item-box">
              <div>
                <mat-checkbox [checked]="row?.checked || row.status" (change)="toggleCheckbox($event, row)" id="{{row.itemuuid}}" [value]="i+1"
                  [disabled]="(ScoringTypeId != row.scoringTypeId || row.status == true)">
                </mat-checkbox>
              </div>
              <div class="item-desc">
                <ng-container *ngIf="row?.itemBankName?.length > 40 then sliceTitle else noSliceTitle">
                </ng-container>
                <ng-template #sliceTitle>
                  <div class="text-bold" (click)='navigateToItemDetails(row.itemBankId)' matTooltip="{{row?.itemBankName}}"
                    matTooltipPosition="above">
                    {{row?.itemBankName | slice: 0:50}}...</div>
                </ng-template>
                <ng-template #noSliceTitle>
                  <div class="text-bold" (click)='navigateToItemDetails(row.itemBankId)'>{{row?.itemBankName
                    }}</div>
                </ng-template>
                <div class="test-desc">
                  <ng-container *ngIf="row?.itemDescription?.length > 30 then sliceDescription else noSliceDescription">
                  </ng-container>
                  <ng-template #sliceDescription>
                    <div class="text-bold" (click)='navigateToItemDetails(row.itemBankId)' matTooltipPosition="above"
                      matTooltip="{{row?.itemDescription}}">
                      {{row?.itemDescription | slice: 0:30}}...
                    </div>
                  </ng-template>
                  <ng-template #noSliceDescription>
                    <div class="text-bold" (click)='navigateToItemDetails(row.itemBankId)'>
                      {{row?.itemDescription }}
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="scoringtype">
          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">
            {{'testId.TabItems.existingItem.column2' | translate}}
          </th>
          <!-- <td mat-cell *matCellDef="let row" ng-disabled="ScoringTypeId != row.scoringTypeId">
            {{row.scoringTypeId == 1 ? ScoringTypeNameEnum.OnQuestion : row.scoringTypeId == 3 ? ScoringTypeNameEnum.On180360Degree : ScoringTypeNameEnum.OnOption}}
          </td> -->
          <td mat-cell *matCellDef="let row" ng-disabled="ScoringTypeId != row.scoringTypeId">
            {{row.scoringTypeId == 1 ? ('items.questionScoring' | translate): row.scoringTypeId == 3 ? ('items.DICSStyle' | translate) : ('items.optionScoring' | translate)}}
          </td>
        </ng-container>

        <ng-container matColumnDef="styleGroup">
          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'testId.TabItems.existingItem.column7' | translate}}</th>
          <td mat-cell *matCellDef="let row" ng-disabled="ScoringTypeId != row.scoringTypeId">{{row.styleGroupName}}
          </td>
        </ng-container>

        <ng-container matColumnDef="questiontype">
          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">
            {{'testId.TabItems.existingItem.column3' | translate}}
          </th>
          <td mat-cell *matCellDef="let row" ng-disabled="ScoringTypeId != row.scoringTypeId">
            {{row.questionTypes}}</td>
        </ng-container>

        <ng-container matColumnDef="itemStatus">
          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">
            {{'testId.TabItems.existingItem.column4' | translate}}
          </th>
          <td mat-cell *matCellDef="let row" ng-disabled="ScoringTypeId != row.scoringTypeId">
            <i *ngIf="row?.statusName === 'Published'" class="fa fas fa-circle publish"
            matTooltip="{{'testId.TabItems.existingItem.statusTooltip.published' | translate}}"></i>
            <span *ngIf="row?.statusName === 'Unpublished'" class="glyphicon glyphicon-adjust unpublish" matTooltip="{{'testId.TabItems.existingItem.statusTooltip.unPublished' | translate}}"></span>
          </td>
        </ng-container>
        <ng-container matColumnDef="updated">
          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">
            {{'testId.TabItems.existingItem.column5' | translate}}
          </th>
          <td mat-cell *matCellDef="let row" ng-disabled="ScoringTypeId != row.scoringTypeId">
            <div class="text-bold"> {{row.modifiedUserName}} </div>{{row.updated | dateAgo}}
          </td>
        </ng-container>
        <!-- <ng-container matColumnDef="tags">
                    <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">Tag(s)</th>
                    <td mat-cell *matCellDef="let row">
                        <ng-container *ngIf="row?.tagdescription.length > 2; then Slicetag; else noSlicetag" ></ng-container>
                        <ng-template #Slicetag>
                           <div class="tag-data">
                                <table>
                                    <tr *ngFor="let ele of row.tagdescription" >
                                        <td [innerHtml]="ele | boldTag" matTooltip="{{row.tagdescription}}"></td>
                                    </tr>
                                </table>
                           </div>
                        </ng-template>
                        <ng-template #noSlicetag>
                            <table>
                                <tr *ngFor="let ele of row.tagdescription">
                                    <td [innerHtml]="ele | boldTag"></td>
                                </tr>
                            </table>
                        </ng-template>
                    </td>
                </ng-container> -->

        <ng-container matColumnDef="tags">
          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">
            {{'testId.TabItems.existingItem.column6' | translate}}
          </th>
          <td mat-cell *matCellDef="let row" ng-disabled="ScoringTypeId != 2">
            <ng-container *ngIf="row.tagdescription.length > 2 then sliceDesc else nosliceDesc"></ng-container>
            <ng-template #sliceDesc>
              <div class="tag-data">
                <table>
                  <tr>
                    <td class="display-wrap" *ngIf="row.tagdescription.length > 40" [innerHtml]="(row.tagdescription | boldTag | slice: 0:44)+'...'"
                      matTooltipPosition="above" matTooltip="{{row?.tagdescription}}" matTooltipClass="my-custom-tooltip"></td>
                    <td class="display-wrap" *ngIf="row.tagdescription.length < 40 || row.tagdescription.length==40" matTooltipPosition="above"
                      matTooltip="{{row?.tagdescription}}" [innerHtml]="(row.tagdescription | boldTag)"></td>
                  </tr>
                </table>
              </div>
            </ng-template>
            <ng-template #nosliceDesc>
              <table>
                <tr>
                  <td class="display-wrap" *ngIf="row.tagdescription.length > 40" [innerHtml]="(row.tagdescription | boldTag | slice: 0:44)+'...'"
                    matTooltipPosition="above" matTooltip="{{row?.tagdescription}}" matTooltipClass="my-custom-tooltip"></td>
                  <td class="display-wrap" matTooltipPosition="above" matTooltip="{{row?.tagdescription}}" matTooltipClass="my-custom-tooltip"
                    *ngIf="row.tagdescription.length < 40 || row.tagdescription.length==40" [innerHtml]="(row.tagdescription | boldTag)"></td>
                </tr>
              </table>
            </ng-template>

          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <!-- <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'disabled': (ScoringTypeId != row.scoringTypeId || styleGroupId != row.styleGroupid || row.status == true)}"></tr> -->
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'disabled': (ScoringTypeId != row.scoringTypeId || row.status == true)}"></tr>
      </table>
      <div class="data-not-found-container" *ngIf="noDataFound">
        <p>{{'testId.TabItems.existingItem.errorMsg' | translate}}</p>
      </div>
    </div>
    <div class="test-paginator">
      <mat-paginator [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</div>
